export function ChildAttribute({attrType, attrValue, hideIfEmpty=false}) {
  if (hideIfEmpty && !attrValue) {
    return null;
  }

  return (
    <>
      <span className="child-info__attributes-type">{attrType}</span>
      <span className="child-info__attributes-value">{attrValue}</span>
    </>
  )
}

export default ChildAttribute;